 const parseNumber = (value) => {
    const numeric = value !== undefined && value !== null ? Number(value) : NaN;
    const afterParsed = Number.isFinite(numeric)
      ? numeric.toFixed(2).replace(/\.?0+$/, "") || "0"
      : "--";
    return afterParsed;
  };

  export default parseNumber
